<template>
  <div>
    <div class="min-vh-100" v-if="isLoginPage">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col xl="4" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">LIVE</h1>
        </b-col>
        <b-col xl="8" class="text-center text-sm-left   mb-3 mb-sm-0">
          <div class="w-100 action-div"></div>
        </b-col>
      </CRow>

      <div class="mt-3 bg-white-border p-3">
        <b-tabs content-class="mt-3">
          <b-tab title="Live" active>
            <PostTable :pageId="pageId" :postTypeId="1" />
          </b-tab>
          <b-tab title="Post">
            <PostTable :pageId="pageId" :postTypeId="2" />
          </b-tab>
        </b-tabs>
      </div>
      <template>
        <div>
          <!-- <b-button id="show-btn" @click="$bvModal.show('bv-modal-example')"
            >Open Modal</b-button
          > -->

          <b-modal
            id="bv-modal-example"
            hide-footer
            no-close-on-backdrop
            hide-header
          >
            <template #modal-title> </template>
            <div class="d-block text-center">
              <h3>ยังไม่ได้เชื่อม Facebook Page</h3>
              กรุณาเชื่อม Facebook Page ก่อนใช้งานเมนู Live
            </div>
            <b-button
              class="mt-3"
              block
              @click="goSettingPage"
              variant="primary"
              >ไปยังหน้าเชื่อม Facebook Page</b-button
            >
          </b-modal>
        </div>
      </template>
    </div>

    <ModalAlert ref="modalAlert" :text="modalMessage" />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalAlertConfirm
      msg="ยืนยันการลบ ?"
      :text="modalMessage"
      btnConfirm="ลบ"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="ModalAlertConfirm"
      @confirm="btnDelete"
    />
  </div>
</template>

<script>
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import PostTable from "./Component/PostTable.vue";
export default {
  name: "LiveIndex",
  components: {
    PostTable,
    ModalAlert,
    ModalAlertError,
    ModalAlertConfirm,
  },
  data() {
    return {
      pageId: null,
      modalMessage: "",
      startPage: 1,
      endPage: 10,
      activeItem: "",
      requestDeleteUser: {
        userId: null,
      },

      items: [],
      isBusy: false,
      value: false,

      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      totalRowMessage: "",
      isDisable: false,
      checkAll: false,
      selectAllCb: false,
      isLoginPage: false,
    };
  },
  created: async function() {
    await this.checkLoginPage();
    if (!this.isLoginPage) {
      this.$bvModal.show("bv-modal-example");
      return;
    }
    // await this.getList();
    // this.getPage(1);
  },
  methods: {
    goSettingPage() {
      this.$router.push({ path: `/setting` }).catch(() => {});
    },
    async checkLoginPage() {
      await this.axios
        .get(`${this.$baseUrl}/livePost/checkLoginPage`)
        .then((data) => {
          console.log("check login page", data);
          if (data.result == 1) {
            this.isLoginPage = data.detail.id != 0;
            if (this.isLoginPage) {
              this.pageId = data.detail.pageId;
            }
            console.log("login page", this.isLoginPage);
          }
        });
    },
    getList: async function() {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/livePost/list`, this.filter)
        .then((data) => {
          console.log("get list", data);
          if (data.result == 1) {
            this.items = data.detail.dataList;
            this.rows = data.detail.count;
            this.isBusy = false;
          }
        });
    },

    onTabChange(postTypeId) {
      this.filter.postTypeId = postTypeId;
      this.filter.paging.pageNo = 1;
      this.getList();
    },
    pagination(Page) {
      this.filter.paging.pageNo = Page;
      this.getList();
      this.getPage(Page);
    },
    getPage(Page) {
      const totalRow = this.rows;
      this.startPage = (Page - 1) * this.filter.paging.perPage + 1;
      if (Page * this.filter.paging.perPage <= totalRow) {
        this.endPage = Page * this.filter.paging.perPage;
      } else {
        this.endPage = totalRow;
      }
    },
    hanndleChangeperPage(value) {
      this.filter.paging.pageNo = 1;
      this.filter.paging.perPage = value;
      this.getList();
    },
    openModalDelete(value) {
      this.requestDeleteUser.userId = value.userGUID;
      this.modalMessage = "คุณต้องการลบ " + value.username + " ใช่หรือไม่?";
      this.$refs.ModalAlertConfirm.show();
    },
    btnDelete: async function() {
      this.$refs.ModalAlertConfirm.hide();
      await this.axios
        .delete(`${this.$baseUrl}/user/${this.requestDeleteUser.userId}`)
        .then((data) => {
          this.modalMessage = data.message;
          if (data.result == 1) {
            this.$refs.modalAlert.show();
            this.filter.paging.pageNo = 1;
            this.$refs.modalAlert.hide();
            this.getList();
          } else {
            this.$refs.modalAlertError.show();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.action-div {
  text-align: end;
}
.word {
  border: 0px solid #cecdcd;
  border-radius: 24px;
  padding: 0.5rem 0.75rem;
  background-color: #f0eff9;
  display: inline-flex;
  margin: 0.5rem;
  justify-content: space-between;
  align-items: flex-start;
}
.word-container {
  border: 1px solid #cecdcd;
  border-radius: 4px;
  padding: 1rem;
  height: 600px;
  overflow-y: scroll;
}
@media (max-width: 767px) {
  .action-div {
    text-align: center;
  }
}
</style>
